/* tslint:disable */

declare var Object: any;
export interface JobAcknowledgementInterface {
  "JobSfdcId"?: string;
  "Dispatch_Job_num__c"?: string;
  "PreVisitStartDate"?: Date;
  "PreVisitAcknowledgeDate"?: Date;
  "SubmittedById"?: string;
  "SubmittedBy"?: string;
  "Jobsite_ID__c"?: string;
  "Jobsite_Zip__c"?: string;
  "WorkerId"?: string;
  "WorkerName"?: string;
  "PartnerId"?: string;
  "PartnerName"?: string;
  "ProgramId"?: string;
  "ProgramName"?: string;
  "VendorId"?: string;
  "VendorName"?: string;
  "BrowserName"?: string;
  "BrowserMetaData"?: string;
  "concernType__c"?: string;
  "remark"?: string;
  "isAcknowledge"?: boolean;
  "id"?: number;
  "createdAt"?: Date;
  "updatedAt"?: Date;
}

export class JobAcknowledgement implements JobAcknowledgementInterface {
  "JobSfdcId": string;
  "Dispatch_Job_num__c": string;
  "PreVisitStartDate": Date;
  "PreVisitAcknowledgeDate": Date;
  "SubmittedById": string;
  "SubmittedBy": string;
  "Jobsite_ID__c": string;
  "Jobsite_Zip__c": string;
  "WorkerId": string;
  "WorkerName": string;
  "PartnerId": string;
  "PartnerName": string;
  "ProgramId": string;
  "ProgramName": string;
  "VendorId": string;
  "VendorName": string;
  "BrowserName": string;
  "BrowserMetaData": string;
  "concernType__c": string;
  "remark": string;
  "isAcknowledge": boolean;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  constructor(data?: JobAcknowledgementInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `JobAcknowledgement`.
   */
  public static getModelName() {
    return "JobAcknowledgement";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of JobAcknowledgement for dynamic purposes.
  **/
  public static factory(data: JobAcknowledgementInterface): JobAcknowledgement{
    return new JobAcknowledgement(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'JobAcknowledgement',
      plural: 'JobAcknowledgements',
      path: 'JobAcknowledgements',
      idName: 'id',
      properties: {
        "JobSfdcId": {
          name: 'JobSfdcId',
          type: 'string'
        },
        "Dispatch_Job_num__c": {
          name: 'Dispatch_Job_num__c',
          type: 'string'
        },
        "PreVisitStartDate": {
          name: 'PreVisitStartDate',
          type: 'Date'
        },
        "PreVisitAcknowledgeDate": {
          name: 'PreVisitAcknowledgeDate',
          type: 'Date'
        },
        "SubmittedById": {
          name: 'SubmittedById',
          type: 'string'
        },
        "SubmittedBy": {
          name: 'SubmittedBy',
          type: 'string'
        },
        "Jobsite_ID__c": {
          name: 'Jobsite_ID__c',
          type: 'string'
        },
        "Jobsite_Zip__c": {
          name: 'Jobsite_Zip__c',
          type: 'string'
        },
        "WorkerId": {
          name: 'WorkerId',
          type: 'string'
        },
        "WorkerName": {
          name: 'WorkerName',
          type: 'string'
        },
        "PartnerId": {
          name: 'PartnerId',
          type: 'string'
        },
        "PartnerName": {
          name: 'PartnerName',
          type: 'string'
        },
        "ProgramId": {
          name: 'ProgramId',
          type: 'string'
        },
        "ProgramName": {
          name: 'ProgramName',
          type: 'string'
        },
        "VendorId": {
          name: 'VendorId',
          type: 'string'
        },
        "VendorName": {
          name: 'VendorName',
          type: 'string'
        },
        "BrowserName": {
          name: 'BrowserName',
          type: 'string'
        },
        "BrowserMetaData": {
          name: 'BrowserMetaData',
          type: 'string'
        },
        "concernType__c": {
          name: 'concernType__c',
          type: 'string'
        },
        "remark": {
          name: 'remark',
          type: 'string'
        },
        "isAcknowledge": {
          name: 'isAcknowledge',
          type: 'boolean'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
      }
    }
  }
}
